import { SimpleGrid, Box, Center } from "@chakra-ui/react"
import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import '../../css/rgg.css';
import { Stanje01 } from "../stanje/Stanje01";
import {Stanje02} from "../stanje/Stanje02";

export default function Dashboard({headerIcon}) {
    const _currDate=new Date().toISOString().split("T")[0];
    //const _currDatePrevYear=(Number(_currDate.substring(0,4))-1).toString()+_currDate.substring(4,_currDate.length);
  return (

   // <Box  w='99%' pt='0.5rem'>
    <Box w={'100%'}>
            <ComponentHeader component={GruntComponents.DashBoard}/>
            <Box pl='2'>
                {headerIcon}
            </Box>
            <Center>
            <SimpleGrid minChildWidth='40%' spacing='10px' w={'100%'} >
                <Box  rounded={'sm'} key={'b1'} >
                    <Stanje01 _datum={_currDate}/>
                </Box>
                <Box rounded={'sm'} key={'b2'}>
                    <Stanje02/>
                </Box>
                <Box  rounded={'sm'}>
                
                </Box>
                <Box  rounded={'sm'}>
                
                </Box>
                <Box rounded={'sm'}>
                
                </Box>
               
            </SimpleGrid>
            
            </Center>
            
        </Box>

    

  )
}
